<div #animationRoot class="navbar-nav flex-wrap" [ngClass]="{ 'flex-row': vertical==='false', 'justify-content-end': aligned === 'RIGHT', 'justify-content-center': aligned === 'CENTER' }" role="menu" nav-list-items>
  <ng-content select="template[nav-list-items]"></ng-content>
</div>
